import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VMenu, {
    attrs: {
      "open-on-hover": "",
      bottom: "",
      "offset-y": "",
      "close-on-content-click": false,
      transition: "scale-transition",
      "max-width": "500"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c("div", _vm._g(_vm._b({}, "div", attrs, false), on), [_c(VIcon, _vm._g(_vm._b({
          staticClass: "fas fa-exclamation-triangle",
          attrs: {
            color: "orange",
            size: "1rem"
          }
        }, "v-icon", attrs, false), on))], 1)];
      }
    }])
  }, [_c(VCard, [_c(VCardTitle, [_vm._v("Draft Editing Not Recommended Here")]), _c(VCardText, [_c("p", [_vm._v(' This will not modify the Excel files already generated and available in "dashboard/kpi". Changes made here may be lost if you click again on Generate Price Posting again or Duplicate from previous month, from "dashboard/kpi". This should only be used to resync the posted prices in HAL with those on the platform, in case the platform prices differ. ')]), _c("p", [_vm._v(" For draft entries, it's recommended to make changes directly from the wine detail page in Edit Discounts, or by updating the COGS. After making those changes, you should then regenerate the price posting. ")])])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };